import { createAsyncThunk } from '@reduxjs/toolkit';
import deleteUser from 'services/users/deleteUser';

export const deleteUserAction = createAsyncThunk('users/deleteUser', async (uid) => {
  const result = await deleteUser(uid);

  return result;
});
